<template>
    <li class="col-span-1 bg-white border border-gray-200 rounded-lg shadow divide-y divide-gray-200">
        <div class="w-full flex items-center justify-between p-6 space-x-6">
            <div class="flex-1 truncate">
                <h2 class="text-md tracking-widest uppercase font-bold text-gray-700">Latest Subscription</h2>
                <div class="flex items-center space-x-3">
                    <h3 class="text-gray-900 text-lg font-medium truncate">N/A</h3>
                </div>
                <p class="mt-1 text-gray-500 text-sm truncate">
                    This customer is not currently enrolled in a subscription package.
                </p>
            </div>
        </div>
        <div>
            <div class="-mt-px flex divide-x divide-gray-200">
                <div class="w-0 flex-1 flex">
                    <a href="#" @click.prevent="newSale" class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                        <CurrencyPoundIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                        <span class="ml-3">New Sale</span>
                    </a>
                </div>
                <div class="-ml-px w-0 flex-1 flex">

                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { toRef } from "vue"
import { CurrencyPoundIcon } from "@heroicons/vue/24/outline"
import {useRouter} from "vue-router"

export default {
    name: "EmptySubscriptionBlock",
    components: {
        CurrencyPoundIcon,
    },
    props: {
        user: {
            type: Object,
            required: true,
        }
    },
    setup(props, context) {
        const vueRouter = useRouter()

        const newSale = () => {
            vueRouter.push({ name: 'sales.new', params: { userId: props.user.id } })
        }

        return {
            newSale,
        }
    }
}
</script>

<style scoped>

</style>
